<main>
  <app-loading-spinner-overlay *ngIf="uploadPending"></app-loading-spinner-overlay>

  <header>
    <img src="/assets/img/obt-logo.png" alt="obt-logo" />
    <h1>{{ mobileUpload.customerSpaceName }}</h1>
    <ul class="breadcrumbs mobile-upload-theme-breadcrumbs">
      <li *ngFor="let locationPart of mobileUpload.locationParts">{{ locationPart }}</li>
    </ul>
  </header>

  <form [formGroup]="formGroup" (ngSubmit)="onFormSubmit()" (reset)="onFormReset()">
    <section *ngIf="!files" class="upload">
      <span>{{ 'mobile-upload.upload.upload-title' | translate }}</span>
      <button type="button" mat-flat-button color="primary" (click)="fileUpload.click()" class="full-width">
        {{ 'mobile-upload.upload.file-select' | translate }}
      </button>
      <input type="file" (change)="onFileSelected($event)" style="display: none" multiple #fileUpload />
      <small class="hint mobile-upload-theme-hint">
        {{ 'mobile-upload.upload.expiration-hint' | translate: { expirationMinutes: mobileUpload.expirationMinutes } }}
      </small>
    </section>

    <section *ngIf="files" class="preview">
      <ul>
        <li *ngFor="let file of files">
          <app-mobile-upload-file-preview
            [file]="file.file"
            [fileExtension]="file.extension"
            [inputName]="file.id"
            [formGroup]="formGroup"
          ></app-mobile-upload-file-preview>
        </li>
      </ul>
      <button type="submit" mat-flat-button color="primary" class="full-width" [disabled]="!formGroup.valid">
        {{ 'mobile-upload.upload.submit' | translate }}
      </button>

      <button type="reset" mat-flat-button class="full-width cancel">{{ 'shared.cancel' | translate }}</button>
    </section>
  </form>
</main>
